var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt-custom-overlay-field"},[_c(_vm.componentName,{tag:"component",attrs:{"field":_vm.field},on:{"change":_vm.valueChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }